import type {AxiosRequestConfig} from 'axios';
import {Center, Status} from './interface';

export class DeleteCenterBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.centersRequest.url = `/centers/${id}`;
    return this;
  }
  build() {
    return this.centersRequest;
  }
}
export class GetAllCentersRequestBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/centers',
    params: {},
  };

  id(id: number) {
    this.centersRequest.url = `/centers/${id}`;
    return this;
  }
  params(params: object) {
    this.centersRequest.params = params;
    return this;
  }

  build() {
    return this.centersRequest;
  }
}
export class GetCentersCountRequestBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/centers/count',
    params: {},
  };
  params(params: object) {
    this.centersRequest.params = params;
    return this;
  }

  build() {
    return this.centersRequest;
  }
}

export class CreateCenterRequestBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/centers',
    data: {},
  };

  data(data: Center) {
    this.centersRequest.data = data;
    return this;
  }

  build() {
    return this.centersRequest;
  }
}

export class UpdateCenterRequestBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/centers',
    data: {},
  };
  id(id: number) {
    this.centersRequest.url = `/centers/${id}/admin`;
    return this;
  }
  data(body: Center | number) {
    this.centersRequest.data = body;
    return this;
  }
  build() {
    return this.centersRequest;
  }
}

export class UpdateCenterStatusRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };
  id(id: number) {
    this.request.url = `/centers/${id}/status`;
    return this;
  }
  data(body: Status) {
    this.request.data = `"${body}"`;
    return this;
  }
  build() {
    return this.request;
  }
}

export class GetAllCentersReportRequestBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/centers/report',
    params: {},
  };

  params(params: object) {
    this.centersRequest.params = params;
    return this;
  }

  build() {
    return this.centersRequest;
  }
}

export class GetAllCenterStaristicsRequestBuilder {
  private readonly centersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/centers/statistics',
    params: {},
  };

  id(id: number) {
    this.centersRequest.url = `/centers/${id}/statistics`;
    return this;
  }
  params(params: object) {
    this.centersRequest.params = params;
    return this;
  }

  build() {
    return this.centersRequest;
  }
}
